//import React from 'react'
import Form from 'react-bootstrap/Form';
import Button from 'react-bootstrap/Button';
import { useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
//import { addNewPost } from './postsSlice';
import { selectAllUsers } from '../users/usersSlice';
import { useNavigate } from 'react-router-dom';

import { adders } from './homesSlice_old';
import { FeatureForCamelCaseCRUD } from './homesSlice_old';



const AddFormHome = () => {
  const dispatch = useDispatch();

  const navigate = useNavigate();

  const [title, setTitle] = useState('');
  const [content, setContent] = useState('');
  const [userId, setUserId] = useState('');
  const [main, setMain] = useState('');
  const [pilar, setPilar] = useState('');
  const [addRequestStatus, setAddRequestStatus] = useState('idle');
  
  const users = useSelector(selectAllUsers);
  
  const onTitleChange = e => setTitle(e.target.value);
  const onContentChange = e => setContent(e.target.value);
  const onAuthorChange = e => setUserId(e.target.value);
  const onMainTitleChange = e => setMain(e.target.value);
  const onPilarChange = e => setPilar(e.target.value);
  const canSave = [title, content, userId].every(Boolean) && addRequestStatus === 'idle';


  const onSavePostClicked = () => {
    if(canSave) {
      try{
        setAddRequestStatus('pending');
        dispatch(adders[`addNew${FeatureForCamelCaseCRUD}`]({title, content, userId, main, pilar})).unwrap();
        
        setUserId('');
        setTitle('');
        setContent('');
        navigate('/')
        
      }catch(err){
        console.error('Failed to save the post', err)
      }finally{
        setAddRequestStatus('idle')
      }
      window.location.reload();   
    }
  }

  const handleKeyDown = (e) => {
    if (e.key === 'Enter') {
      e.preventDefault();
      onSavePostClicked();
    }
  };

  const usersOptions = users.map((user) => (
    <option value={user.id} key={user.id}>
      {user.name}
    </option>
  ))

  return (
    <div className="container">
      <h2>Add a new Admin Post</h2>
      <Form onSubmit={onSavePostClicked}>
      <Form.Control 
          type="checkbox"
          id="mainTitle"
          name="main"
          placeholder="Should the title be featured"
          value={main} 
          onChange={onMainTitleChange}
          
        />
        {/* <label htmlFor="postAuthor">Author</label> */}
        <Form.Control as="select" 
          name="postAuthor" 
          id="postAuthor"
          placeholder="Select" 
          value={userId}
          onChange={onAuthorChange}
        >
          <option value=""></option>
          {usersOptions}
        </Form.Control>
        {/* <label htmlFor="title">Title</label> */}
        <Form.Control 
          type="text"
          id="postTitle"
          name="title"
          placeholder="Your post title"
          value={title}
          onChange={onTitleChange} 
        />
        <Form.Control 
          type="text"
          id="pilar"
          name="pilar"
          placeholder="Your post pilar"
          value={title}
          onChange={onPilarChange}
          onKeyDown={handleKeyDown}
        />
        {/* <label htmlFor="content">Content</label> */}
        <Form.Control as="textarea" 
          type="text"
          id="postContent"
          name="content"
          placeholder="Your post content"
          value={content}
          onChange={onContentChange} 
          onKeyDown={handleKeyDown}
        />
        <Button
          type='button'
          //onClick={onSavePostClicked}
          disabled={!canSave}
          variant="outline-warning"
          size="block"
        >Save post</Button>
      </Form>
    </div>
  )
}

export default AddFormHome